var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyAnalitcsPerformance = function SvgEmptyAnalitcsPerformance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 268,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D6F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E5F6",
    offset: "16.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4FB",
    offset: "39.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFCFE",
    offset: "65.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.872%",
    y1: "-2.336%",
    x2: "24.635%",
    y2: "89.541%",
    id: "EmptyAnalitcsPerformance_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "32.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEEFA",
    offset: "54.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D9F9",
    offset: "91.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.07%",
    y1: "-4.568%",
    x2: "41.096%",
    y2: "104.724%",
    id: "EmptyAnalitcsPerformance_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D33",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECF9",
    offset: "33.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "67.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "92.8%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECF9",
    offset: "32.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "65.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.002%",
    x2: "100%",
    y2: "50.002%",
    id: "EmptyAnalitcsPerformance_svg__f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__g"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__h"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.932%",
    y1: "-1.92%",
    x2: "45.386%",
    y2: "89.791%",
    id: "EmptyAnalitcsPerformance_svg__i"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "16%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3192",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__j"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECF9",
    offset: "27.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "55.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "76.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyAnalitcsPerformance_svg__k"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D8F2",
    offset: "8.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EAF5",
    offset: "64.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.003%",
    x2: "100%",
    y2: "50.003%",
    id: "EmptyAnalitcsPerformance_svg__l"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyAnalitcsPerformance_svg__m"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECF9",
    offset: "27.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "55.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "76.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "100%",
    y2: "49.999%",
    id: "EmptyAnalitcsPerformance_svg__n"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECF9",
    offset: "27.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "55.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "76.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__o"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "31.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECF9",
    offset: "56.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "81.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__p"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECF9",
    offset: "27.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "55.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "76.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECF9",
    offset: "27.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "55.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "76.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__r"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECF9",
    offset: "27.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "55.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "76.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__s"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D7F3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9ECF9",
    offset: "32.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "65.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyAnalitcsPerformance_svg__t"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__u"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.001%",
    x2: "100%",
    y2: "50.001%",
    id: "EmptyAnalitcsPerformance_svg__v"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.998%",
    x2: "100%",
    y2: "49.998%",
    id: "EmptyAnalitcsPerformance_svg__w"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__x"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.002%",
    x2: "100%",
    y2: "50.002%",
    id: "EmptyAnalitcsPerformance_svg__y"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__z"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E4",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DAED",
    offset: "57.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA",
    offset: "84.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "EmptyAnalitcsPerformance_svg__C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.998%",
    x2: "100.001%",
    y2: "49.998%",
    id: "EmptyAnalitcsPerformance_svg__D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C9E4",
    offset: "42.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7DAED",
    offset: "57.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5FA",
    offset: "84.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "49.999%",
    x2: "99.998%",
    y2: "49.999%",
    id: "EmptyAnalitcsPerformance_svg__E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC16B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF6B",
    offset: "1.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F38764",
    offset: "34.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5E60",
    offset: "63.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5455D",
    offset: "86.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E33C5C",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "25.147%",
    y1: "89.526%",
    x2: "64.007%",
    y2: "-2.355%",
    id: "EmptyAnalitcsPerformance_svg__F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3F8",
    offset: ".6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.969%",
    y1: "102.895%",
    x2: "25.412%",
    y2: "6.426%",
    id: "EmptyAnalitcsPerformance_svg__G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: ".6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B67E9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EC",
    offset: "9.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "82.771%",
    y1: "65.217%",
    x2: "24.056%",
    y2: "36.551%",
    id: "EmptyAnalitcsPerformance_svg__I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302B8E",
    offset: "51.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3834.543%",
    y1: "-11.596%",
    x2: "-3769.352%",
    y2: "-33.857%",
    id: "EmptyAnalitcsPerformance_svg__J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#302B8E",
    offset: "51.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.9%",
    y1: "0%",
    x2: "52.385%",
    y2: "109.395%",
    id: "EmptyAnalitcsPerformance_svg__K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE5020",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".001%",
    y1: "50%",
    x2: "100.001%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__L"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EC",
    offset: "9.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100.001%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED3EC",
    offset: "9.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EBF6",
    offset: "40.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFD",
    offset: "68.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "89.9%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".001%",
    y1: "49.999%",
    x2: "99.996%",
    y2: "49.999%",
    id: "EmptyAnalitcsPerformance_svg__N"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A35A0",
    offset: "30.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241E77",
    offset: "89.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4517.84%",
    y1: "50.001%",
    x2: "-4417.843%",
    y2: "50.001%",
    id: "EmptyAnalitcsPerformance_svg__O"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A35A0",
    offset: "30.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#241E77",
    offset: "89.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".001%",
    y1: "50%",
    x2: "100.001%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#423EAF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353097",
    offset: "30.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#251F7A",
    offset: "74.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F196F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__Q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__R"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__S"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBC0E6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E7F5",
    offset: "66.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "EmptyAnalitcsPerformance_svg__T"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFD5F1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E5F6",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FD",
    offset: "71.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.738 45.198c-1.493.743-4.658 1.327-7.289 1.327-.43 0-.814-.017-1.161-.046.131-.145.287-.266.459-.359 1.382-.797 4.743-1.443 7.507-1.443.17 0 .327.005.484.01v-.511l-3.413-1.968a51.16 51.16 0 0 0-5.122.711l-11.251 2.163 3.75 2.164.009.004 1.79 1.033c1.851 1.068 7.415 1.18 13.015.338l1.222-.704v-2.72Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__a)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.188 34.835a2.411 2.411 0 0 0-.183-.976c.917-.101 1.565.56 1.565 1.773 0 1.593-1.12 3.532-2.502 4.33-1.05.605-1.948.375-2.318-.469a2.43 2.43 0 0 0 .936-.33c1.382-.796 2.502-2.735 2.502-4.329Z",
    fill: "#CED3F8",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.935 34.114c2.071-3.582 5.43-5.521 7.501-4.326l1.383.797c-2.072-1.195-5.43.744-7.502 4.327-2.069 3.58-2.07 7.45-.003 8.648l-1.379-.794c-2.071-1.194-2.07-5.067 0-8.652Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__b)",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m57.317 43.563 3.751 2.163 3.75-6.489c2.072-3.584 2.072-7.457 0-8.652-2.071-1.195-5.43.744-7.5 4.327-2.07 3.584-2.072 7.457 0 8.651Zm1.25-5.045c0-1.594 1.119-3.533 2.5-4.33 1.383-.797 2.503-.15 2.503 1.444 0 1.593-1.12 3.532-2.502 4.33-1.382.796-2.502.15-2.502-1.444Z",
    fill: "#BBC0E6",
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m111.1 175.492-3.844-2.216c-.179-.104-.354-.209-.525-.316l1.509-.8c.151.094.307.187.466.28l3.844 2.216-1.45.836Zm8.7 5.017-4.35-2.508 1.45-.836 4.35 2.508-1.45.836Zm-16.562-10.694a7.106 7.106 0 0 1-1.396-3.648l2.048-.05a6.317 6.317 0 0 0 1.242 3.245l-1.894.453Zm-.541-7.35a10.521 10.521 0 0 1 3.016-3.305l1.619.725a9.358 9.358 0 0 0-2.681 2.939l-1.954-.358Zm8.799-5.086-1.45-.836 3.503-2.02c.262-.151.518-.31.77-.475l1.544.778c-.283.186-.57.364-.864.533l-3.503 2.02Zm5.795-6.177a6.145 6.145 0 0 0 1.087-3.263l2.05.018a6.906 6.906 0 0 1-1.222 3.668l-1.915-.423Zm.17-6.543a9.806 9.806 0 0 0-2.82-2.894l1.583-.752a11.034 11.034 0 0 1 3.173 3.257l-1.936.39Zm-41.84-25.461-4.35-2.509 1.45-.836 4.35 2.509-1.45.836Zm-8.7-5.017-4.349-2.509 1.45-.836 4.35 2.509-1.45.836Zm-8.699-5.017-4.35-2.509 1.45-.836 4.35 2.508-1.45.837Zm-8.7-5.017-4.349-2.509 1.45-.836 4.35 2.508-1.45.837Zm60.897 35.119-4.35-2.509 1.45-.836 4.35 2.509-1.45.836Zm-8.7-5.017-4.35-2.509 1.45-.836 4.35 2.509-1.45.836Zm-8.699-5.017-4.35-2.509 1.45-.836 4.35 2.509-1.45.836Zm-8.7-5.017-4.35-2.509 1.45-.836 4.35 2.509-1.45.836ZM41.44 98.588a7.493 7.493 0 0 1-1.68-3.608l2.043-.103a6.664 6.664 0 0 0 1.494 3.209l-1.857.502Zm-1.113-7.328a9.75 9.75 0 0 1 2.754-3.381l1.674.682a8.667 8.667 0 0 0-2.447 3.006l-1.98-.307Zm8.477-5.227-1.45-.836 4.35-2.509 1.45.837-4.35 2.508Zm8.7-5.017-1.45-.836 4.349-2.509 1.45.836-4.35 2.509Zm8.699-5.017-1.45-.836 4.35-2.509 1.45.836L66.202 76Zm8.699-5.017-1.45-.836 4.35-2.509 1.45.836-4.35 2.509Zm8.7-5.017-1.45-.836L86.5 62.62l1.45.836-4.35 2.509Zm8.699-5.017-1.45-.836 4.018-2.318 1.45.836-4.018 2.318Z",
    fill: "#FFD03E",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "m7.666 52.678 43.256-24.946-1.16-.67-1.161-.67L5.344 51.34l1.16.67z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__c)",
    fillRule: "nonzero",
    d: "M50.922 67.33 7.666 92.277V52.678l43.256-24.946z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m7.666 92.277-2.322-1.34V51.339l2.322 1.34v39.598z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__d)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M50.922 67.33 7.666 92.277h55.63l43.256-24.947h-55.63z"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m220.955 40.938-31.068 17.917V19.257L220.955 1.34z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m189.887 58.855-2.321-1.34V17.918l2.321 1.34z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "M220.955 1.34 218.632 0l-31.066 17.917 2.321 1.34z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__e)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M32.229 111.984h45.627v36.456H32.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__f)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M47.094 121.955h-9.505l5.941 3.533-5.94 3.428h9.504l6.032-3.48z"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m37.59 128.916 5.94-3.428v-6.958l-5.94 3.425z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m37.59 128.916-5.942-3.428v-6.958l5.941 3.425z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "m37.59 121.955-5.942-3.425 5.941-3.426 5.941 3.426-5.94 3.425z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BA2A1",
    fillRule: "nonzero",
    d: "M34.55 112.606 4.646 129.853V90.255L34.55 73.007z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "M32.229 148.44 0 129.854V90.255l32.229 18.586v39.599z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m34.55 147.1-2.321 1.34V108.84l2.321-1.339z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "M34.55 107.502 4.645 90.255 34.55 73.007l-1.161-.67-1.161-.669L0 90.255l32.229 18.586 2.321-1.339z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__g)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m282.15 58.775-30.128.08-62.134 35.834H125.43l62.136 35.834h68.662l-37.623-21.698 63.545-36.647z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__h)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M126.592 59.524 65.618 94.69h68.662l60.974-35.165z"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__i)",
    fillRule: "nonzero",
    d: "M108.736 67.144 78.829 49.897V10.298l29.907 17.247v39.599z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BA2A1",
    fillRule: "nonzero",
    d: "M126.593 59.525 65.618 94.689V55.091l60.975-35.165v39.599z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m158.821 40.938-29.906 17.247V18.587L158.82 1.34z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BA2A1",
    fillRule: "nonzero",
    d: "m186.404 94.019-59.811-34.494V19.926l59.81 34.494z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__j)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m156.256 76.632-29.663-56.706v39.599l29.663 17.107z"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m252.022 58.855-92.04 53.081V72.337l92.04-53.08z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "M187.566 130.523 125.43 94.69V55.09l62.136 35.834z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m189.887 129.183-2.321 1.34V90.924l2.321-1.34z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m63.296 53.751 1.16.67 1.162.67 31.068-17.917 29.907-17.248 29.906 17.248 29.905 17.246L157.658 71 127.753 53.75l-2.323 1.34 31.068 17.916 31.068 17.917 2.321-1.34-29.906-17.247 29.906-17.247 31.068-17.917-2.323-1.34-29.906 17.248-29.905-17.247-29.906-17.247L158.82 1.34 156.5 0l-31.067 17.917-14.374 8.29L81.152 8.958l-2.323 1.34 29.907 17.246-14.372 8.289-31.068 17.917ZM249.7 17.917l-31.067 17.917 2.322 1.34 31.067-17.918-2.322-1.34Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m65.618 94.69-2.322-1.34V53.75l2.322 1.34z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__k)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M125.43 74.901v-7.453h-8.913l6.361 3.783-6.361 3.67h8.913z"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#56B1B0",
    fillRule: "nonzero",
    d: "m116.517 74.901 6.361-3.67V63.78l-6.361 3.669v7.453z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7978",
    fillRule: "nonzero",
    d: "m116.517 74.901-6.363-3.67V63.78l6.363 3.669v7.453z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#74DDDC",
    fillRule: "nonzero",
    d: "m116.517 67.448-6.363-3.669 6.363-3.668 6.361 3.668z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__l)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M120.334 59.9h-5.527l3.455 2.054-3.455 1.993h5.527l3.508-2.024z"
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m114.807 63.947 3.455-1.993v-4.047l-3.455 1.992z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m114.807 63.947-3.455-1.993v-4.047l3.455 1.992z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "m114.807 59.9-3.455-1.993 3.455-1.992 3.455 1.992z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__m)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m157.66 149.11-29.907 17.247 59.813-.14 29.907-17.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__n)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m219.794 149.11-31.067 17.917 53.474-.141 31.068-17.918z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__o)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m282.15 111.99-60.033-.14 31.067 18.002-31.067 17.917 60.033-.14z"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#4BA2A1",
    fillRule: "nonzero",
    d: "m155.337 147.77-60.974-35.164V73.007l60.974 35.165v39.598z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m249.7 130.522-31.068-17.916V73.007L249.7 90.924z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m157.658 149.11-29.905 17.247V126.76l29.905-17.248v39.598Zm62.136 0-31.067 17.917v-39.599l31.067-17.917v39.598Zm33.39-19.258-31.067 17.918v-39.6l31.067-17.916v39.598Z",
    fill: "#BBC0E6",
    fillRule: "nonzero"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m246.258 164.371-26.464-15.262v-39.598l26.464 15.262v39.598z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m248.58 163.032-2.322 1.34v-39.6l2.323-1.338z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m188.727 167.027-31.068-17.918v-39.598l31.068 17.917v39.599Zm-60.974-.67-2.322-1.34v-39.598l2.322 1.34v39.598Z",
    fill: "#CED3F8",
    fillRule: "nonzero"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "m253.184 90.255-32.229-18.587-2.323 1.34 29.907 17.247-29.906 17.247h-.001l-29.906 17.248-29.906-17.248-31.067-17.917-31.068-17.917-2.322 1.34 31.067 17.916 29.907 17.248-29.906 17.247 2.322 1.34 29.906-17.248 31.068 17.917 31.067-17.917 26.464 15.262 2.323-1.34-26.464-15.262z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__p)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m187.323 166.217-29.664-56.706v39.598z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__q)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M246.258 164.371V160.1l-26.464-50.59v39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__r)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M160.923 146.068H92.26l4.426 2.372-63.296 36.503h68.662l63.296-36.503z"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "M94.364 107.502 63.296 125.42 33.39 142.667 9.2 128.715l-2.322 1.34 26.512 15.29 32.228-18.586 31.067-17.918-1.16-.67-1.161-.669z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m33.39 184.943-26.512-15.29v-39.599l26.512 15.29z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "M96.685 148.44 33.39 184.943v-39.598l63.295-36.504v39.599z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__s)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M94.364 183.652h45.628v36.455H94.364z"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "M96.685 184.274 66.78 201.52v-39.599l29.906-17.248v39.6z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "m95.524 144.006-1.16-.67-32.23 18.586 32.23 18.587 2.321-1.34-29.906-17.247 29.906-17.248-1.16-.668z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m94.364 220.108-32.23-18.587v-39.599l32.23 18.587v39.599z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m96.685 218.767-2.32 1.34V180.51l2.32-1.34z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__t)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M181.647 161.029h-9.791l6.12 3.64-6.12 3.531h9.791l6.216-3.585-6.216-3.586z"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#56B1B0",
    fillRule: "nonzero",
    d: "m171.856 168.2 6.12-3.532V157.5l-6.12 3.529v7.171z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7978",
    fillRule: "nonzero",
    d: "m171.856 168.2-6.122-3.532V157.5l6.122 3.529v7.171z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#74DDDC",
    fillRule: "nonzero",
    d: "m171.856 161.029-6.122-3.53 6.122-3.529 6.12 3.53z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__u)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M103.082 220.465H90.904l7.612 4.526-7.612 4.39h12.178l7.729-4.457-7.73-4.46z"
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m90.904 229.382 7.612-4.391v-8.916l-7.612 4.39v8.917z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m90.904 229.382-7.613-4.391v-8.916l7.613 4.39v8.917z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "m90.904 220.465-7.613-4.39 7.613-4.389 7.612 4.39z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__v)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M262.765 62.28h-12.177l7.612 4.527-7.612 4.391h12.177l7.73-4.458-7.73-4.46z"
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m250.588 71.198 7.612-4.391V57.89l-7.612 4.39v8.917z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m250.588 71.198-7.612-4.391V57.89l7.612 4.39v8.917z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "m250.588 62.28-7.612-4.389 7.612-4.389 7.612 4.39z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__w)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M60.134 201.716h-7.299l4.563 2.713-4.563 2.631h7.3l4.632-2.672-4.633-2.672z"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#56B1B0",
    fillRule: "nonzero",
    d: "m52.835 207.06 4.563-2.631v-5.344l-4.563 2.63v5.345z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7978",
    fillRule: "nonzero",
    d: "m52.835 207.06-4.562-2.631v-5.344l4.562 2.63z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#74DDDC",
    fillRule: "nonzero",
    d: "m52.835 201.716-4.562-2.631 4.562-2.63 4.563 2.63-4.563 2.63z"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__x)",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M11.862 5.261h-7.3l4.563 2.713-4.562 2.632h7.299l4.632-2.672-4.632-2.673z",
    transform: "translate(243.685 68.45)"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#56B1B0",
    d: "m248.247 79.057 4.563-2.632V71.08l-4.563 2.63z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B7978",
    d: "m248.247 79.057-4.562-2.632V71.08l4.562 2.63z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#74DDDC",
    d: "m248.247 73.712-4.562-2.63 4.562-2.631 4.563 2.63z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__y)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M30.016 217.209h-6.251l3.907 2.323-3.907 2.254h6.25l3.968-2.288z"
  }), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m23.765 221.786 3.907-2.254v-4.576l-3.907 2.253z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m23.765 221.786-3.908-2.254v-4.576l3.908 2.253z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "m23.765 217.209-3.908-2.253 3.908-2.253 3.907 2.253z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__z)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M181.3 168.827h-6.404l4.003 2.38-4.003 2.31h6.403l4.065-2.345z"
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBC0E6",
    fillRule: "nonzero",
    d: "m174.896 173.516 4.003-2.31v-4.687l-4.003 2.308v4.69z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m174.896 173.516-4.003-2.31v-4.687l4.003 2.308v4.69z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6FB",
    fillRule: "nonzero",
    d: "m174.896 168.827-4.003-2.308 4.003-2.308 4.003 2.308z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__A)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M193.314 208.466h-11.278l7.051 4.191-7.05 4.066h11.277l7.158-4.127z"
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    fillRule: "nonzero",
    d: "m182.036 216.723 7.051-4.066v-8.256l-7.05 4.065v8.257z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    fillRule: "nonzero",
    d: "m182.036 216.723-7.051-4.066v-8.256l7.051 4.065v8.257z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    fillRule: "nonzero",
    d: "m182.036 208.466-7.051-4.065 7.051-4.065 7.051 4.065z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFE4F4",
    fillRule: "nonzero",
    d: "m184.725 204.4-2.689-1.55-2.69 1.55 2.69 1.55z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.948 177.592c-1.259-.727-2.933-1.062-4.577-1.012h-2.579V177a6.857 6.857 0 0 0-1.364.59c-2.344 1.363-2.33 3.569.029 4.931.423.24.87.433 1.335.577v.441h3.092c1.488-.024 2.961-.36 4.093-1.017 2.345-1.363 2.332-3.57-.029-4.931Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__B)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M115.801 182.524c-1.188-.685-1.782-1.585-1.779-2.482l.005-2.047c-.002.899.591 1.797 1.78 2.483 2.36 1.361 6.174 1.361 8.519 0 1.165-.676 1.749-1.56 1.751-2.447l-.006 2.046c-.002.886-.585 1.771-1.75 2.447-2.344 1.363-6.16 1.363-8.52 0Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__C)",
    fillRule: "nonzero"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M115.806 180.478c-2.36-1.361-2.373-3.568-.028-4.93 2.345-1.36 6.16-1.36 8.52 0 2.361 1.362 2.373 3.569.027 4.93-2.343 1.361-6.158 1.361-8.519 0Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#CED3F8",
    fillRule: "nonzero",
    d: "m123.462 179.348-3.595-2.073.791-.457-3.624-.544.946 2.09.79-.457 3.595 2.072 1.097-.631z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.613 99.45c-1.259-.726-2.934-1.062-4.578-1.012h-2.578v.422a6.85 6.85 0 0 0-1.364.59c-2.345 1.362-2.33 3.568.029 4.93.423.24.87.433 1.335.578v.44h3.092c1.487-.024 2.961-.36 4.093-1.017 2.344-1.363 2.332-3.57-.029-4.931Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__D)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M74.466 104.383c-1.188-.686-1.782-1.585-1.78-2.483l.006-2.047c-.002.899.59 1.798 1.779 2.483 2.36 1.361 6.175 1.361 8.52 0 1.165-.676 1.748-1.56 1.751-2.447l-.006 2.046c-.002.887-.585 1.771-1.75 2.448-2.345 1.361-6.16 1.361-8.52 0Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__E)",
    fillRule: "nonzero"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M74.47 102.336c-2.36-1.361-2.372-3.568-.028-4.929 2.346-1.362 6.162-1.362 8.52 0 2.362 1.36 2.373 3.568.028 4.93-2.344 1.36-6.158 1.36-8.52 0Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.871 122.1v23.325l-3.813 2.199v-18.66l-.347.2-2.831 7.497-3.986 2.3 5.2-13.528 5.777-3.333Zm-29.43-27.453c0 4.599-2.398 5.348-6.645 4.133-2.83-.8-4.333-.966-4.333 1.2v.398l10.862 6.264v4l-14.676-8.464V98.18c0-4.232 2.63-4.781 6.356-3.798 2.889.766 4.622.666 4.622-2.066 0-2.3-1.357-4.448-3.438-5.648-2.08-1.2-3.842-.85-3.842 2.183v.732l-3.813-2.199v-.8c0-5.464 3.496-6.247 7.598-3.881 3.928 2.266 7.309 7.147 7.309 11.945ZM48.457 32.638v3.866L42.852 45v.4l.752-.433c2.802-1.616 5.315-.833 5.315 3.399 0 4.731-3.12 9.596-7.626 12.195-4.825 2.782-7.742 1.166-7.742-3.466v-.932l3.813-2.2v.8c0 2.266 1.357 3.349 3.928 1.866 2.398-1.383 3.814-3.832 3.814-6.064 0-2.233-1.358-2.55-3.294-1.433l-3.524 2.032v-3.931l4.998-7.614-9.158 5.281v-3.998l14.329-8.264Z",
    fill: "#D1D7F3",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M72.615 64.482c0-3.785 2.66-8.387 5.942-10.28 3.281-1.893 5.942-.358 5.942 3.427s-2.66 8.387-5.942 10.28c-3.281 1.892-5.942.358-5.942-3.427Z",
    fill: "#BBC0E6",
    fillRule: "nonzero"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M81.377 52.993c-1.077-.637-2.571-.555-4.225.399-3.282 1.892-5.942 6.495-5.942 10.28 0 1.974.728 3.328 1.886 3.911l-.003.006 1.205.695c-1.04-.635-1.683-1.946-1.683-3.802 0-3.785 2.66-8.387 5.942-10.28 1.64-.945 3.123-1.035 4.198-.418l-1.376-.793-.002.002Zm1.384.795.022.016.001-.002-.023-.014ZM74.498 68.4l.004-.007c-.027-.014-.056-.024-.083-.038l.08.045Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__F)",
    fillRule: "nonzero"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M82.897 58.228c0-1.389-.465-2.382-1.22-2.895-.822-.397-1.915-.303-3.12.392-2.552 1.472-4.622 5.052-4.622 7.995 0 1.39.466 2.383 1.22 2.896.823.397 1.916.302 3.12-.392 2.554-1.472 4.622-5.052 4.622-7.996Z",
    fill: "#F6F6FB",
    fillRule: "nonzero"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M81.678 55.333c.754.513 1.22 1.506 1.22 2.895 0 2.944-2.07 6.524-4.622 7.996-1.205.694-2.298.789-3.12.392.844.574 2.053.547 3.4-.23 2.554-1.472 4.622-5.052 4.622-7.996 0-1.554-.58-2.614-1.5-3.057Z",
    fill: "#CED3F8",
    fillRule: "nonzero"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m81.031 62.097-2.593-1.496v-3.227c0-.205-.144-.287-.321-.185a.71.71 0 0 0-.321.556v3.38a.32.32 0 0 0 .024.127.175.175 0 0 0 .07.08l2.687 1.55c.125.073.329-.044.454-.261.126-.217.126-.452 0-.524Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__G)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m150.437 88.56 1.69-.974-3.199-5.533 15.242 8.79v-2.756l-15.242-8.79 3.198-1.844-1.69-2.924-6.081 3.508 6.082 10.524Zm54.258-36.993 1.69.975-3.198 5.533 15.241-8.79v2.757l-15.241 8.79 3.198 1.844-1.69 2.923-6.082-3.508 6.082-10.524ZM66.89 145.074l-1.69-.974 3.199-5.534-15.242 8.79V144.6l15.242-8.79-3.199-1.844 1.69-2.924 6.082 3.508-6.082 10.524Z",
    fill: "#F1F1F6",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__H)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "m166.19 202.72-15.342.008-1.76 2.964h4.036l-.925 1.557 13.991-.007z"
  }), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M150.442 176.28c0 .28-.956 3.81-1.162 4.164-.295.509-.808 1.04-.932 1.368a5.234 5.234 0 0 0-.246 1.15c0 .17.219.767.432.682.213-.085-.098-.395.006-.5.043.097.286.342.5.3.214-.043.136-.12.136-.12.113.04.264.042.306-.045.096.032.257.114.297-.127.041-.244.07-.647.17-.8.32-.498.283-1.688.347-1.838.064-.148 1.238-3.087 1.338-3.707.1-.622.087-3.74-.461-3.763-.547-.024-.731 2.346-.731 3.237Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M152.202 202.564c.65.106.838 1.155.513 1.811a2.51 2.51 0 0 1-.711.438s-2.055.842-2.517.879c-.463.037-1.49-.136-1.573-.924.079-.482.484-.614.983-.91.647-.384 1.203-.941 1.725-1.197.43-.211 1.58-.097 1.58-.097Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__I)",
    fillRule: "nonzero"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M150.954 201.898a31.59 31.59 0 0 1 1.337.304s.377 1.055-.219 1.243c-1.157.362-2.143-.414-1.688-.674.306-.174.607-.372.57-.873Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M149.501 205.481c.476-.038 2.59-.904 2.59-.904.258-.106.497-.251.71-.43a1.423 1.423 0 0 1-.086.228 2.51 2.51 0 0 1-.711.438s-2.055.842-2.517.879c-.463.037-1.49-.136-1.573-.924.004-.017.009-.03.012-.047.219.648 1.14.796 1.575.76Z",
    fill: "#121047",
    fillRule: "nonzero"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M150.188 202.927c.086-.115.286-.42.64-.167a.841.841 0 0 1 .409.841c-.043.263-.805.067-.833.03-.03-.041-.216-.704-.216-.704Z",
    fill: "#362E93",
    fillRule: "nonzero"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M149.84 203.254c.294.145.536.38.689.671a.208.208 0 0 0 .276.1.21.21 0 0 0 .1-.28 1.97 1.97 0 0 0-.903-.873.208.208 0 0 0-.163.382Zm-.643.41c.296.145.537.38.689.67a.209.209 0 0 0 .377-.178 1.949 1.949 0 0 0-.902-.874.209.209 0 1 0-.164.383Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M151.132 181.167c-.312 3.864-.83 7.543-.83 10.644 0 3.548.617 7.284.654 10.258-.032.912 1.004 1.626 1.442.822.018-.265-.105-.601-.06-.99.265-2.265 1.04-5.744.388-8.671.898-3.882 3.374-8.679 3.008-11.725-1.124-.557-3.74-.611-4.602-.338Zm.498-12.234c-1.015.5-1.385 1.259-1.385 2.77.693-.424 1.385-2.77 1.385-2.77Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#423EAF",
    fillRule: "nonzero",
    d: "M152.174 182.64v.649l.561-.324-.561-.325z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M154.914 204.123c.651.105.838 1.154.512 1.811-.21.185-.45.333-.71.437 0 0-2.056.843-2.517.878-.462.038-1.489-.133-1.572-.924.078-.48.483-.613.982-.908.648-.384 1.203-.942 1.725-1.198.43-.211 1.58-.096 1.58-.096Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__J)",
    fillRule: "nonzero"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M153.665 203.456a31.42 31.42 0 0 1 1.338.304s.378 1.056-.219 1.243c-1.156.362-2.142-.414-1.687-.674.305-.174.606-.37.568-.873Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M152.213 207.04c.476-.039 2.59-.903 2.59-.903.258-.107.497-.253.71-.432a1.388 1.388 0 0 1-.087.23c-.21.184-.45.332-.71.436 0 0-2.056.843-2.517.878-.462.038-1.489-.133-1.572-.924.002-.014.008-.03.011-.047.219.65 1.14.797 1.575.762Z",
    fill: "#121047",
    fillRule: "nonzero"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M152.9 204.484c.086-.113.286-.418.639-.167a.844.844 0 0 1 .41.842c-.043.263-.804.068-.832.029-.03-.04-.217-.704-.217-.704Z",
    fill: "#362E93",
    fillRule: "nonzero"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M152.552 204.813c.295.145.536.38.689.67a.207.207 0 0 0 .276.1.21.21 0 0 0 .1-.278 1.96 1.96 0 0 0-.903-.875.208.208 0 1 0-.162.383Zm-.642.41c.295.145.536.38.688.67a.208.208 0 1 0 .377-.178 1.944 1.944 0 0 0-.902-.876.209.209 0 0 0-.163.384Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M153.258 182.83c0 3.553-.037 7.524-.037 10.626 0 3.548.41 7.197.448 10.171-.033.913 1.003 1.627 1.441.822.018-.265-.106-.601-.06-.99.265-2.263 1.041-5.744.388-8.671.898-3.881 2.285-7.972 1.46-11.93-1.124-.558-2.779-.3-3.64-.028Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M155.934 178.264c-.295-2.677.97-5.202 1.202-6.874.146-1.055.251-2.29-.705-2.588-.989-.308-1.388-.452-2.244-.43-2.064.05-3.032.475-3.452 1.894-.395 1.336-.676 1.743-1.002 3.054-.146.586 1.473 1.863 1.284 4.398-1.433 2.166-2.461 7.06-2.9 10.902-.167 1.158 1.013 2.647 3.098 3.69 2.631 1.314 5.697 1.42 6.849.235.265-.264.42-.618.434-.992.003-1.363-.773-11.067-2.564-13.29Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__K)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M154.92 165.862c-.038-.634-2.21.628-2.162 1.465.04.682.13 1.366-.126 1.454-.296.214-1.178 2.474-.65 3.001 1.846-.754 2.808-2.35 4.45-2.98-.673-.137-1.395-.885-1.513-2.94Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m155.442 164.985-.653-1.633h-4.143v2.49c0 1.375.928 2.49 2.071 2.49 1.11 0 2.009-1.05 2.062-2.37l.288.01.375-.987Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M154.42 167.239a2 2 0 0 1-1.617 1.086.671.671 0 0 1-.105.411c.11.002.22-.008.328-.03a1.987 1.987 0 0 0 1.395-1.467Z",
    fill: "#F2C29D",
    fillRule: "nonzero"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M152.99 161.616a.154.154 0 0 0-.039-.002c-2.26.058-2.43 1.745-2.305 2.024.717.256 1.169-.23 1.619-.191.217.017 1.1.137 1.464.604.393.501.268 1.303.638 1.284.16-.007.209-.546.449-.559a.404.404 0 0 1 .38.484c-.031.414-.424.667-.367.866.097.329.923-.262.91-1.44-.018-1.17-.8-3.15-2.75-3.07Z",
    fill: "#1F196F",
    fillRule: "nonzero"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M156.994 179.536s.443 1.106.445 1.106c1.548-.807 2.456-2.913 2.545-4.613.12-2.29-2.255-6.16-2.38-6.344-.6-.895-2.026-.102-1.555 1.046.103.23 2.534 4.225 2.275 5.577-.18.932-.486 2.644-1.33 3.228Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M153.275 161.62c2.402.17 2.69 2.535 3.645 3.176.57.381 1.842-.34 2.587.95.858 1.48-.529 2.019.379 2.646.907.627 1.606 2.541.093 3.719-1.514 1.173-3.409.141-3.195-1.581.154-1.238-.214-1.877-1.256-1.477-.78.3-1.078-.316-.727-1.109-1.735.174.084-3.132-2.536-4.497.099-.675 1.01-1.828 1.01-1.828Z",
    fill: "#1F196F",
    fillRule: "nonzero"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M156.994 179.536c-.182.117-1.176-.117-1.412-.117a4.95 4.95 0 0 0-1.426.176c-.542.173-.912.371-.542.457-.199.044-.67.235-.3.342.036.128.172.299.578.284.438.176.906.263 1.377.257.307.093 1.92.06 2.17-.293a1.922 1.922 0 0 0-.445-1.106Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__L)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M134.25 213.805h14.881v2.732h-14.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__M)",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M141.016 209.86h14.88v2.732h-14.88z"
  }), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M142.543 211.752c0-2.147-1.362-2.21-1.362-2.21s-.737 0-1.936-.496c-1.18-.49-2.847-.301-1.916 1.414.009.023.02.044.032.065.078.11.181.201.302.263l2.975 1.745c.454.257 1.894-.34 1.905-.781Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__N)",
    fillRule: "nonzero"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M142.535 211.559c-.026.44-1.447 1.027-1.897.77l-2.975-1.742a2.73 2.73 0 0 1-.42-.306c.027.06.051.116.086.18.009.022.02.043.032.064.078.11.181.201.302.263l2.975 1.745c.425.242 1.715-.268 1.886-.697a.5.5 0 0 0 .013-.087 1.397 1.397 0 0 0-.002-.19Z",
    fill: "#121047",
    fillRule: "nonzero"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M141.989 209.261a12.49 12.49 0 0 0-1.585.313.682.682 0 0 1-.11.32l-.035.042c-.244.168-.491.435.087.798a.803.803 0 0 0 1.04-.073.936.936 0 0 1 .336-.382.862.862 0 0 1 .321-.135l.003-.03s.09-.853-.057-.853Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M142.01 188.274c-1.344.025-4.707.086-6.052.109.5 4.04 1.51 7.708 2.18 11.62.724 3.803 1.537 6.474 2.247 9.638.261.59 1.45.366 1.692-.2.188-2.914.404-6.465-.46-9.827.144-3.623.48-7.68.394-11.34Z",
    fill: "#1F196F",
    fillRule: "nonzero"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M135.76 215.694c0-2.145-1.362-2.207-1.362-2.207s-.737 0-1.935-.497c-1.182-.49-2.848-.3-1.917 1.414.01.022.02.043.032.064a.827.827 0 0 0 .303.264l2.974 1.744c.455.258 1.894-.339 1.905-.782Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__O)",
    fillRule: "nonzero"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M135.752 215.502c-.025.44-1.447 1.027-1.897.77l-2.974-1.74a2.908 2.908 0 0 1-.42-.307c.028.059.05.115.085.179.01.022.02.043.032.064a.827.827 0 0 0 .303.264l2.974 1.744c.425.242 1.716-.267 1.886-.696a.434.434 0 0 0 .013-.088 1.471 1.471 0 0 0-.002-.19Z",
    fill: "#121047",
    fillRule: "nonzero"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M135.206 213.203c-.534.07-1.064.176-1.584.315a.699.699 0 0 1-.11.32c-.013.013-.024.027-.035.04-.244.17-.492.438.086.8a.803.803 0 0 0 1.04-.074.964.964 0 0 1 .658-.516c0-.01.001-.02.003-.029 0 0 .09-.856-.058-.856Z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M137.743 197.88c.367-1.737 4.61-1.952 4.33-8.78-1.33-.196-8.045 2.95-9.375 2.755-.167 4.066.227 7.851.251 11.82.091 3.868.457 6.637.64 9.875.16.624 1.37.598 1.702.078.662-2.845 1.455-6.311 1.153-9.77.395-1.915.867-3.945 1.299-5.978Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__P)",
    fillRule: "nonzero"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M139.004 175.84c4.737 3.163 5.302 9.442 2.74 13.426 0 0 .55-8.829-2.74-13.425Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__Q)",
    fillRule: "nonzero"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M139.22 192.97c-2.882 1.617-5.9 1.62-6.927-.367.384-3.7.745-6.71.003-10.256.218-1.958.373-2.251.122-3.394.088-.383 1.268-1.2 2.127-1.985.929-.846 1.555-1.65 2.033-1.749 3.943-.803 5.859 6.215 5.529 13.696-.305 1.99-1.467 3.26-2.886 4.055Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__R)",
    fillRule: "nonzero"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M138.765 175.667c-.855-.618-.787-1.894-.715-2.742.14-.475.195-.97.16-1.464-.126-1.866-1.426-3.4-2.878-3.2-2.925.399-2.298 1.91-2.172 3.776.117 1.73.983 2.867 2.31 2.978.019.286-.098 1.148-.456 1.508.963.575 2.367.304 2.923.054.59-.267 1.23-.496.828-.91Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M134.163 167.35c.07-.234.517-.387 2.037.198.01.004.368.144.392.152 2.813 1.218 2.134 4.458 1.713 5.319-.176.31-.253.665-.22 1.02-1.107-.046-1.457.575-2.165-.044-.509-.443-1.268-.963-1.396-1.181a.863.863 0 0 1-.103-.536c-.004-1.553-.721-.605-.698-.247-.294-.143-.274-.768-.255-1.462-2.388-1.78-1.107-3.008.695-3.22Z",
    fill: "#362E93",
    fillRule: "nonzero"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M132.635 193.971a.976.976 0 0 0 1.428.048c.466-.491.197-1.036.454-1.2.699-.447.86-.869.741-1.292-.558.354-1.134.923-1.622.578-.488-.345-1.122-.821-1.157-1.314-.726.166-.763 1.738-.385 2.37.16.283.34.554.54.81Z",
    fill: "#FCD1A9",
    fillRule: "nonzero"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M133.617 192.736c.36.878.107 1.417-.775 1.517-2.201-1.125-3.48-4.283-3.518-6.016-.063-2.893 1.342-6.523 3.128-9.37.415-.613 1.753-.381 2.412.488.892 1.174.51 2.884.006 3.579-1.294 2.065-2.735 3.603-2.876 5.257-.13 1.532.496 3.55 1.623 4.545Z",
    fill: "url(#EmptyAnalitcsPerformance_svg__S)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#EmptyAnalitcsPerformance_svg__T)",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M78.495 53.548H30.197L60.39 71.499 30.197 88.918h48.298l18.728-10.801.075-13.718-18.803-10.851z",
    transform: "translate(200.702 179.082)"
  }), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BEE4",
    d: "m230.9 268 30.192-17.418v-54.093L230.9 213.901z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#CCD1F6",
    d: "m230.9 268-30.198-17.418v-54.093l30.197 17.412z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F9",
    d: "m230.9 213.9-30.198-17.41 30.197-17.408 30.193 17.407z"
  })))));
};
export default SvgEmptyAnalitcsPerformance;